function createSelectorButton(id: string, title: string): HTMLButtonElement
{
    let selectorButton: HTMLButtonElement = document.createElement("button");
    selectorButton.className = "btn btn-secondary dropdown-toggle selector-btn";
    selectorButton.setAttribute('type', 'button');
    selectorButton.setAttribute('data-bs-toggle', 'dropdown');
    selectorButton.setAttribute('aria-expanded', 'false');
    selectorButton.innerText = title;
    selectorButton.id = id;
    return selectorButton;
}

function createSingleItem(itemName: string, selectorButton: HTMLButtonElement): HTMLAnchorElement
{
    let anchorElement: HTMLAnchorElement = document.createElement("a");
    anchorElement.className = "dropdown-item";
    anchorElement.href = "#";
    anchorElement.innerText = itemName;
    anchorElement.onclick = function (e)
    {
        e.preventDefault();
        if (this instanceof HTMLAnchorElement)
            selectorButton.innerText = this.innerText; // Update the button text with selected player name
    };
    return anchorElement;
}

function createItemsMenu(selectorButton: HTMLButtonElement, items: string[]): HTMLUListElement
{
    let menuElement: HTMLUListElement = document.createElement("ul");
    menuElement.className = "dropdown-menu";
    for (let itemName of items)
    {
        let itemElement: HTMLLIElement = document.createElement("li");
        itemElement.appendChild(createSingleItem(itemName, selectorButton));
        menuElement.appendChild(itemElement);
    }
    return menuElement;
}

export function CreateDropDownButton(id: string, title: string, items: string[]): HTMLDivElement
{
    let playersDiv: HTMLDivElement = document.createElement("div");
    playersDiv.className = "dropdown";
    let selectorButton: HTMLButtonElement = createSelectorButton(id, title);
    playersDiv.appendChild(selectorButton);
    playersDiv.appendChild(createItemsMenu(selectorButton, items));
    return playersDiv;
}

//---------------------------------------------------------------------------------------------------
export function CreateArraySelector<Type>(arr: Type[], additionalClass: string,
    transformFunc: (entry: Type) => string,
    colorFunc?: (entry: Type) => string ): HTMLDivElement
{
    let column: HTMLDivElement = document.createElement("div");
    column.className = "align-self-center";

    let select: HTMLSelectElement = document.createElement("select");
    select.className = "form-select fs-5";
    for (let i = 0; i < arr.length; i++)
    {
        let option = document.createElement("option");
        option.innerHTML = transformFunc(arr[i]!);
        option.value = JSON.stringify(arr[i]);
        if (colorFunc)
            option.style.color = colorFunc(arr[i]!);
        select.appendChild(option);
    }
    select.value = "undefined"; // Default value is 'undefined'
    if (additionalClass)
        select.classList.add(additionalClass);
    column.appendChild(select);

    return column;
}
